import { ScreenOverlay } from "@/components/overlay/screen-overlay";
import { css } from "@/domains/emotion";
import { FC } from "react";
import { ZIndex } from "@/domains/design/constants";
import { AnimatePresence, motion } from "motion/react";
import styled from "@emotion/styled";
import { MDSLoadingIconSize, MDSLoadingIcon } from "@/mds/components/loading/loading-icon";
import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds";

interface LoadingOverlayProps {
  isVisible: boolean;
  animateIn?: boolean;
  loadingMessage?: string;
}

export const LoadingOverlay: FC<LoadingOverlayProps> = ({
  isVisible,
  animateIn = true,
  loadingMessage = "Loading...",
}) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ delay: animateIn ? 0.05 : 0, duration: animateIn ? 0.2 : 0 }}
          className={overlayStyles}
        >
          <ScreenOverlay>
            <MDSLoadingIcon size={MDSLoadingIconSize.Large} />
            <LoadingMessage
              variant={MDSTextVariant.HeaderM}
              weight={MDSTextWeight.Regular}
              color={MDSTextColor.Contrast}
            >
              {loadingMessage}
            </LoadingMessage>
          </ScreenOverlay>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

const overlayStyles = css({
  position: "absolute",
  zIndex: ZIndex.ScreenOverlayLoader,
});

const LoadingMessage = styled(MDSText)`
  margin-top: ${({ theme }) => theme.spacing[4]};
`;
